import { ValidatorRegex } from '@app/config-manager/editor/editor.model';

declare let kendo: any;

export class ValidateIntegerFunction {
  static register(registerFunc = kendo.spreadsheet.defineFunction) {
    registerFunc('VALIDATE_INTEGER', function (str) {
      return ValidatorRegex.integerNotNull.test(str);
    }).args([['str', 'string']]);
  }
}
